import noUiSlider from "nouislider";
import wNumb from "wnumb";

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper)
      facetWrapper.addEventListener("keyup", this.onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");

    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.refreshAjaxinate();
      })
      .finally(() => {
        if (typeof window.compareGridRender === "function") {
          window.compareGridRender();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    //if a wpt, check the toggle state

    const collectionLayoutToggle = document.querySelector(".js-toggle-layout");

    if (collectionLayoutToggle) {
      // get the current layout from the toggle

      const gridLayoutToggle = collectionLayoutToggle.querySelector(
        ".js-toggle-layout--grid"
      );
      const listLayoutToggle = collectionLayoutToggle.querySelector(
        ".js-toggle-layout--list"
      );

      if (gridLayoutToggle.classList.contains("active")) {
        //set to grid layout
        const collectionContainer = document.querySelector(
          ".collection-content__container"
        );
        collectionContainer.classList.remove(
          "collection-content__container--list"
        );

        const productCardsGrid = document.querySelectorAll(".product-card");
        const productCardsList = document.querySelectorAll(
          ".product-card__list"
        );
        const wptContentCards = document.querySelectorAll(
          ".grid__item--wpt-content"
        );

        productCardsGrid.forEach((card) => card.classList.remove("lg:hidden"));
        productCardsList.forEach((card) => card.classList.add("lg:hidden"));
        wptContentCards.forEach((card) =>
          card.classList.add("grid__item--wpt-content--grid")
        );
        gridLayoutToggle.classList.add("active");
      }
      if (listLayoutToggle.classList.contains("active")) {
        //set to list layout
        const collectionContainer = document.querySelector(
          ".collection-content__container"
        );
        collectionContainer.classList.add(
          "collection-content__container--list"
        );
        const productCardsGrid = document.querySelectorAll(".product-card");
        const productCardsList = document.querySelectorAll(
          ".product-card__list"
        );
        const wptContentCards = document.querySelectorAll(
          ".grid__item--wpt-content"
        );
        productCardsGrid.forEach((card) => card.classList.add("lg:hidden"));
        productCardsList.forEach((card) => card.classList.remove("lg:hidden"));
        wptContentCards.forEach((card) =>
          card.classList.remove("grid__item--wpt-content--grid")
        );
        listLayoutToggle.classList.add("active");
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;

    const container = document.getElementById("ProductCount");
    const containers = document.querySelectorAll(".js-product-count");

    //get the page limit set in the customiser
    const pageLimit = document.querySelector(".js-page-limit").innerHTML;
    //convert pagelimit to number
    const pageLimitNumber = parseInt(pageLimit, 10);
    //separate count

    let countResult = count.match(/\d+/g);
    let resultNumber = countResult[1];

    if (pageLimitNumber > resultNumber) {
      containers.forEach((el) => {
        el.innerHTML = `Showing <strong>${resultNumber}</strong> of <strong>${resultNumber}</strong>`;
      });
    } else {
      containers.forEach((el) => {
        el.innerHTML = count;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      let targetElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );

      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      } else {
        //click active-facets__button-remove
        const removeAllFacetsBtn = document.querySelector(
          ".active-facets__button-remove"
        );
        if (removeAllFacetsBtn) {
          removeAllFacetsBtn.click();
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm" ||
            form.id === "FacetFiltersFormDesktop"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }

  static refreshAjaxinate() {
    const Moonbase = window.Moonbase || {};

    const thisAjaxinate = new Moonbase.Ajaxinate({
      container: ".ajaxinate",
      pagination: ".paginate-button",
      previousPagination: ".paginate-previous-button",
      loadingText: "Loading...",
      method: "click",
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    switch (this.dataset.layout) {
      case "fields":
        this.querySelectorAll("input").forEach((element) =>
          element.addEventListener("change", this.onRangeChange.bind(this))
        );

        this.setMinAndMaxValues();
        break;
      case "checkboxes":
        this.selectors = this.querySelectorAll(".selector");
        this.onRangeClick = this.onRangeClick.bind(this);
        this.setEvents();
        break;
      case "slider":
        this.slider = this.querySelector(".noUiSlider-placeholder");
        this.min = Number(this.getAttribute("min"));
        this.max = Number(this.getAttribute("max"));
        this.currentValue = this.getAttribute("value");
        this.currencySymbol = this.getAttribute("symbol");
        this.minInput = this.querySelector(".js-range-min");
        this.maxInput = this.querySelector(".js-range-max");
        this.form = document.getElementById("FacetFiltersForm");

        if (!this.currencySymbol) this.currencySymbol = "£";

        if (!this.currentValue) {
          this.currentValue = [this.min, this.max];
        } else {
          const array = [];
          this.currentValue
            .split(",")
            .forEach((value) => array.push(Number(value)));
          this.currentValue = array;
        }

        this.slider = document.createElement("div");
        this.slider.classList.add("js-range-slider");

        this.prepend(this.slider);
        this.createNoUiSlider();
        this.setEventsSlider();

        break;
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onRangeClick(event) {
    const range = event.target.closest(".range");
    const min = range.querySelector(".min");
    const max = range.querySelector(".max");

    if (event.target.checked) {
      document.querySelectorAll(".range").forEach((element) => {
        if (element.id != range.id) {
          element.querySelector("label input").checked = false;
        }
      });

      min.click();
      max.click();
    } else {
      const removePriceRange = document.querySelector("#remove-price-range");
      removePriceRange.click();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  setEvents() {
    this.selectors.forEach((selector) => {
      selector.addEventListener("click", this.onRangeClick.bind(this));
    });
  }

  createNoUiSlider() {
    noUiSlider.create(this.slider, {
      start: this.currentValue,
      step: 1,
      connect: true,
      range: {
        min: this.min,
        "50%": this.max / 2,
        max: this.max,
      },
      format: {
        decimals: 2,
        thousand: ",",
        to: (value) => value,
        from: (value) => Number(value.replace(",-", "")),
      },
      pips: {
        mode: "range",
        density: 5,
        start: 0,
        format: wNumb({
          decimals: 0,
          prefix: this.currencySymbol,
        }),
      },
    });
  }

  setEventsSlider() {
    this.slider.noUiSlider.on("update", (values, index) => {
      const input = index === 0 ? this.minInput : this.maxInput;
      input.value = Math.round(values[index]);
    });

    this.slider.noUiSlider.on("change", () => {
      this.setMinAndMaxValues();
      this.closest("form").submit();
    });

    const slider = this.slider.noUiSlider;
    this.minInput.addEventListener("change", function () {
      slider.set([this.value, null]);
    });
    this.maxInput.addEventListener("change", function () {
      slider.set([null, this.value]);
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    if (window.innerWidth >= 1024) {
      const mainCollectionFilters = document.querySelector(
        "#main-collection-filters"
      );
      const desktopFacetForm =
        mainCollectionFilters.querySelector("facet-filters-form");
      if (!desktopFacetForm) return;
      desktopFacetForm.onActiveFilterClick(event);
    } else {
      const collectionFilterArea = document.querySelector(
        ".collection-filter-area"
      );
      const mobileFacetForm =
        collectionFilterArea.querySelector("facet-filters-form");
      if (!mobileFacetForm) return;
      mobileFacetForm.onActiveFilterClick(event);
    }
  }
}

customElements.define("facet-remove", FacetRemove);

//add class if filters are open/closed
document.addEventListener("DOMContentLoaded", () => {
  const collection = document.querySelector(".collection-content__container");
  const facetsBtns = document.querySelectorAll(".js-open-facets");
  const facets = document.querySelector(".facets-wrapper");
  const search = document.querySelector(".search-content__container");
  const mainCollectionFilters = document.getElementById(
    "main-collection-filters"
  );

  // Store the original parent and next sibling once
  const originalParent = mainCollectionFilters?.parentNode || null;
  const originalNextSibling = mainCollectionFilters?.nextSibling || null;

  function setFacetsOpen(isOpen, btn) {
    facets.classList.toggle("facets-open", isOpen);
    document.body.classList.toggle("filters-active", isOpen);

    if (window.innerWidth <= 1024) {
      document.body.classList.toggle("overlay--open", isOpen);
    }

    collection?.classList.toggle("facets-open", isOpen);
    search?.classList.toggle("facets-open", isOpen);
    btn.classList.toggle("facets-open", isOpen);

    // Only move filters if viewport is <= 1024px
    if (mainCollectionFilters && originalParent) {
      if (window.innerWidth <= 1024) {
        if (isOpen) {
          document.body.appendChild(mainCollectionFilters);
        } else {
          if (originalNextSibling) {
            originalParent.insertBefore(
              mainCollectionFilters,
              originalNextSibling
            );
          } else {
            originalParent.appendChild(mainCollectionFilters);
          }
        }
      }
    }

    // Set sticky position for desktop
    if (window.innerWidth > 1024) {
      const header = document.querySelector(".main-header");
      if (!facets) return;
      facets.style.position = "sticky";
      facets.style.top = header ? header.offsetHeight + "px" : "0";
    } else {
      facets.style.top = "auto";
    }
  }

  facetsBtns.forEach((facetsBtn) => {
    facetsBtn.addEventListener("click", () => {
      const isActive = document.body.classList.contains("filters-active");
      setFacetsOpen(!isActive, facetsBtn);
    });
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth < 1024) {
      if (!facets) return;
      facets.style.top = "auto";
    }
  });
});

//backup for clicking a facet item and the tick doesn't appear

document.addEventListener("DOMContentLoaded", () => {
  const facetItems = document.querySelectorAll(".list-menu__item.facets__item");
  facetItems.forEach((item) => {
    //on page load if checkbox is checked set aria-checked to true
    if (item.querySelector("input").checked) {
      item
        .querySelector(".checkbox-container")
        .setAttribute("aria-checked", "true");
    } else {
      item
        .querySelector(".checkbox-container")
        .setAttribute("aria-checked", "false");
    }

    item.addEventListener("click", () => {
      //on click make sure aria checkboxes are correct
      if (!item.querySelector("input").checked) {
        item
          .querySelector(".checkbox-container")
          .setAttribute("aria-checked", "true");
      } else {
        item
          .querySelector(".checkbox-container")
          .setAttribute("aria-checked", "false");
      }
      item.querySelector("input").checked =
        !item.querySelector("input").checked;
    });
  });
});

//close mobile facet filters with secondary button

document.addEventListener("DOMContentLoaded", () => {
  const closeFacets = document.querySelectorAll(".js-close-filters");
  const mobileFacets = document.querySelector("#FacetsWrapperMobile");

  if (closeFacets.length > 0) {
    // Add event listener to each close button
    closeFacets.forEach((closeButton) => {
      closeButton.addEventListener("click", () => {
        mobileFacets.classList.remove("overlay--open");
        document.documentElement.classList.remove("overlay--open");
      });
    });
  }
});

//Collection Layout Toggle for WPT

document.addEventListener("DOMContentLoaded", () => {
  const collectionLayoutToggle = document.querySelector(".js-toggle-layout");

  if (collectionLayoutToggle) {
    const gridLayoutToggle = collectionLayoutToggle.querySelector(
      ".js-toggle-layout--grid"
    );
    const listLayoutToggle = collectionLayoutToggle.querySelector(
      ".js-toggle-layout--list"
    );

    gridLayoutToggle.addEventListener("click", () => {
      toggleGridLayout(gridLayoutToggle);
    });
    listLayoutToggle.addEventListener("click", () => {
      toggleGridLayout(listLayoutToggle);
    });
  }
});

function toggleGridLayout(target) {
  const collectionContainer = document.querySelector(
    ".collection-content__container"
  );
  const productCardsGrid = document.querySelectorAll(".product-card");
  const productCardsList = document.querySelectorAll(".product-card__list");
  const wptContentCards = document.querySelectorAll(".grid__item--wpt-content");

  collectionContainer.classList.toggle("collection-content__container--list");
  productCardsGrid.forEach((card) => card.classList.toggle("lg:hidden"));
  productCardsList.forEach((card) => card.classList.toggle("hidden"));
  wptContentCards.forEach((card) =>
    card.classList.toggle("grid__item--wpt-content--grid")
  );

  const gridLayoutToggle = document.querySelector(".js-toggle-layout--grid");
  const listLayoutToggle = document.querySelector(".js-toggle-layout--list");
  gridLayoutToggle.classList.toggle("active");
  listLayoutToggle.classList.toggle("active");
}
